import BookShow from "components/shared/book/show";
import { viewContainer } from "helpers/redux";
import React from "react";

class ShowNotificationQueue extends BookShow {
    getItem = ({ source, match }) => {
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        source.getItem(match.params).then((data) => {
            this.setState({ data, initial: data, ...defParams });
            const config = {
                name: "infoModal",
                windowMod: "wide",
                title: `Тип уведомления - ${data.type}`,
                body: this.logModalBody(data),
                onCloseAction: this.props.back,
            };
            setTimeout(() => this.props.modal(config), 100);
        });
    };

    logModalBody = (original) => {
        const { type, content } = original;
        return (
            <div className="modal--vh-50">
                {type === "Mail" ? (
                    <iframe
                        className="w-100 h-100 border-0 bg-light rounded"
                        sandbox="allow-same-origin"
                        title={`Содержимое уведомления ${type}`}
                        srcDoc={content}
                    />
                ) : (
                    content
                )}
            </div>
        );
    };

    render() {
        return null;
    }
}

export default viewContainer(ShowNotificationQueue, "notification-queue");
